interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'}>
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-wide text-primary-600">
        <span className="w-6 h-px bg-primary-400"></span>
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">{title}</h2>
      {desc && (
        <p className={`mt-4 text-sm md:text-base leading-relaxed text-foreground-600 ${isCenter ? '' : 'max-w-xl'}`}>
          {desc}
        </p>
      )}
    </div>
  );
}